import { render, staticRenderFns } from "./labeling.vue?vue&type=template&id=749bab9d&scoped=true&"
import script from "./labeling.vue?vue&type=script&lang=js&"
export * from "./labeling.vue?vue&type=script&lang=js&"
import style0 from "./labeling.vue?vue&type=style&index=0&id=749bab9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749bab9d",
  null
  
)

export default component.exports